import apiFetch from '../apiFetch'

export default function (token) {    
  return apiFetch({endPoint: `Analisis/saveDataPIC`, method: 'POST', token: token})
}
